import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import {
  breakpointLarge,
  headerColor,
  textColorLight,
  lightBorderAccent,
  linkAccent,
} from "../variables"
import { navData } from "../navData"

const MobileNavigation = ({ isMobileNavOpen }) => {
  return (
    <AnimatePresence>
      {isMobileNavOpen && (
        <NavContainer
          initial={{ y: "-120%" }}
          animate={{ y: "0%" }}
          exit={{ y: "-120%" }}
          transition={{
            damping: 100,
          }}
        >
          {navData.map(link => (
            <Link
              activeClassName="active"
              className="nav-item"
              to={link.to}
              key={link.name}
            >
              {link.name}
            </Link>
          ))}
        </NavContainer>
      )}
    </AnimatePresence>
  )
}

export default MobileNavigation

const NavContainer = styled(motion.nav)`
  position: fixed;
  left: 0;
  width: 100%;
  background: ${headerColor};
  z-index: 20;

  .nav-item {
    height: 60px;
    display: grid;
    place-items: center;
    font-size: 15px;
    font-weight: 700;
    border-top: 2px solid ${lightBorderAccent};
    color: ${textColorLight};
    text-transform: uppercase;
    letter-spacing: 0.15em;

    &.active,
    &:hover {
      background: ${linkAccent};
    }
  }

  @media (min-width: ${breakpointLarge}) {
    display: none;
  }
`
